<div class="header-nav">
  <nav class="header-drop-nav">
    <ul>
      <li>
        <div (click)="showMenu()" class="header-drop-nav-icon"></div>
      </li>
    </ul>
  </nav>
  <nav class="header-main-nav">
    <ul>
      <li *ngFor="let item of (additionalMenuItems$ | async)">
        <a class="cursor-pointer" (click)="handleCustomMenuClick($event, item.url)">{{ item.title }}</a>
      </li>
    </ul>
  </nav>
</div>

<div class="drop-menu" [class.active]="showMenu$ | async" (click)="onDropMenuClick($event)">
  <div class="drop-menu-content">
    <div class="close-menu">
      <a (click)="closeMenu()">
        <img src="./assets/images/icon-menu-close.svg" alt="close menu">
        <p>{{ 'menu.menu' | translate }}</p>
      </a>
    </div>
    <ul class="drop-menu-list">
      <li>
        <ng-container *ngTemplateOutlet="menuItems; context: { items: mainMenuItems$ | async }"></ng-container>
      </li>
    </ul>
    <div class="login-container">
      <!--
        Anonymous only (FE-196): when signed in this rendered a SECOND "My
        profile / Logout" pair beside the Log out the drawer's own Account group
        already carries.

        `[isMenu]` is what keeps `.no-menu` OFF. That class is the HEADER's
        presentation — a horizontal `Log in | Register` pair split by a rule —
        and without this input the drawer inherited it, so the two links sat
        side by side instead of stacking like every other row in the drawer.
        It also switches `handleClick` to emit `closeMenu`, which is why the
        drawer now shuts when you tap one instead of staying open behind the
        page you navigated to.
      -->
      <app-login-logout class="login"
                        *ngIf="(isAuthenticated$ | async) === false"
                        [isMenu]="true"
                        (closeMenu)="closeMenu()"></app-login-logout>
    </div>
    <div *ngIf="accountMenuInMainMenu$ | async" class="quote-button">
      <button mat-button
              type="submit"
              class="mat-btn warning"
              (click)="navigateTo()"
      >
        {{ 'menu.get_a_quote' | translate }}
      </button>
    </div>
  </div>
</div>

<ng-template #menuItems let-items="items">
  <ul>
    <li *ngFor="let item of items" class="{{ item.class ? item.class : '' }}">
      <!--
        FE-196 — a GROUP HEADER ("Account", the phone account sheet's heading)
        carries no url, and rendering it as a link like everything else was
        wrong twice over: tapping it called `navigateByUrl('')` and threw the
        user back to the root, and `curentUrl.includes('')` is always true so it
        also painted itself permanently active. It is a label. Reachable from
        the chip now that the chip opens this drawer on phones, so it is no
        longer a latent bug.
      -->
      <span *ngIf="!item.url; else itemLink" class="drop-menu-group">{{ item.title }}</span>
      <ng-template #itemLink>
        <a class="cursor-pointer"
           [class.active-link]="curentUrl && curentUrl.includes(item.url)"
           (click)="item.url === '#logout' ? logout($event) : handleCustomMenuClick($event, item.url)">
          {{ item.title }}
        </a>
      </ng-template>
      <ng-container *ngIf="item.items">
        <ng-container *ngTemplateOutlet="menuItems; context: { items: item.items }"></ng-container>
      </ng-container>
    </li>
  </ul>
</ng-template>
